import React from 'react';
import { Layers, Check, User, Mail } from 'lucide-react';

const FunnelTemplateMagnet = () => (
  <section className="py-16 md:py-20 bg-white border-t border-green-100">
    <div className="max-w-2xl mx-auto px-4 md:px-6">
      {/* Problem Heading */}
      <div className="text-center mb-4">
        <h1 className="text-3xl md:text-5xl font-extrabold text-green-800 mb-3">"COPY & PASTE" THIS PROVEN FUNNEL THAT'S GENERATING $10K+ MONTHLY FOR WELLNESS COACHES</h1>
        <p className="text-lg md:text-2xl text-green-600 mb-6">Stop reinventing the wheel. This ready-to-deploy funnel template has been battle-tested by hundreds of successful health coaches—just customize and watch your client list grow.</p>
      </div>
      {/* Inviting Image */}
      <div className="flex justify-center mb-8">
        <img src="https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=600&q=80" alt="Funnel Template" className="rounded-xl shadow-lg w-full max-w-md object-cover" />
      </div>
      {/* Form Section */}
      <div className="bg-white rounded-xl shadow-md p-6 mb-10">
        <h4 className="text-lg font-semibold text-green-800 mb-4">🚀 Claim Your Done-For-You Funnel Template</h4>
        <form className="flex flex-col gap-4">
          <div className="flex items-center border rounded-lg px-3 py-2 bg-green-50">
            <User className="w-5 h-5 text-green-400 mr-2" />
            <input type="text" placeholder="First Name" className="bg-transparent flex-1 outline-none text-green-900" required />
          </div>
          <div className="flex items-center border rounded-lg px-3 py-2 bg-green-50">
            <Mail className="w-5 h-5 text-green-400 mr-2" />
            <input type="email" placeholder="Email Address" className="bg-transparent flex-1 outline-none text-green-900" required />
          </div>
          <div className="flex items-center border rounded-lg px-3 py-2 bg-green-50">
            <select className="bg-transparent flex-1 outline-none text-green-900" required defaultValue="">
              <option value="" disabled>Business Stage</option>
              <option>Just Starting</option>
              <option>1-5 Clients</option>
              <option>6-15 Clients</option>
              <option>15+ Clients</option>
            </select>
          </div>
          <button type="submit" className="mt-2 px-6 py-3 bg-green-400 text-white text-lg font-bold rounded-lg shadow-lg hover:bg-green-500 transition duration-300">
            DOWNLOAD MY FUNNEL NOW
          </button>
        </form>
      </div>
      {/* Offer Section */}
      <div className="bg-green-50 rounded-xl shadow-lg overflow-hidden mb-10 md:mb-14">
        <div className="p-6 md:p-8 flex flex-col items-center">
          <Layers className="w-10 h-10 text-green-400 mb-4" strokeWidth={1.5} />
          <h3 className="text-xl font-bold text-green-800 mb-2">What's Included:</h3>
          <ul className="mt-4 space-y-2 text-left">
            <li className="flex items-start"><Check className="w-5 h-5 text-green-400 mr-2 flex-shrink-0 mt-0.5" /><span className="text-green-700 text-sm">The complete "Wellness Authority" funnel structure (value: $997)</span></li>
            <li className="flex items-start"><Check className="w-5 h-5 text-green-400 mr-2 flex-shrink-0 mt-0.5" /><span className="text-green-700 text-sm">7 pre-written email sequences for new lead nurturing</span></li>
            <li className="flex items-start"><Check className="w-5 h-5 text-green-400 mr-2 flex-shrink-0 mt-0.5" /><span className="text-green-700 text-sm">High-converting landing page templates designed specifically for wellness offers</span></li>
            <li className="flex items-start"><Check className="w-5 h-5 text-green-400 mr-2 flex-shrink-0 mt-0.5" /><span className="text-green-700 text-sm">Step-by-step video walkthrough of implementation in our AI platform</span></li>
          </ul>
        </div>
      </div>
      {/* Testimonials Section */}
      <div className="mt-12">
        <h4 className="text-xl font-bold text-green-800 mb-6 text-center">What Smart Coaches Are Saying</h4>
        <div className="relative">
          <div className="flex overflow-x-auto gap-4 pb-4 snap-x snap-mandatory scrollbar-hide">
            <div className="flex-none w-[80%] snap-start">
              <div className="bg-green-50 rounded-lg p-5 shadow flex flex-col h-full">
                <p className="text-green-900 italic mb-2">"I implemented this funnel on a Friday and had 3 discovery calls booked by Monday morning. Two converted to my $2,500 package."</p>
                <span className="text-green-700 font-semibold">— Jason T., Fitness Coach</span>
              </div>
            </div>
            <div className="flex-none w-[80%] snap-start">
              <div className="bg-green-50 rounded-lg p-5 shadow flex flex-col h-full">
                <p className="text-green-900 italic mb-2">"This funnel template saved me months of trial and error. My conversion rate doubled in the first week."</p>
                <span className="text-green-700 font-semibold">— Maria L., Nutrition Coach</span>
              </div>
            </div>
            <div className="flex-none w-[80%] snap-start">
              <div className="bg-green-50 rounded-lg p-5 shadow flex flex-col h-full">
                <p className="text-green-900 italic mb-2">"The email sequences are pure gold. I've never had such high engagement from my leads before."</p>
                <span className="text-green-700 font-semibold">— Chris B., Wellness Consultant</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default FunnelTemplateMagnet; 